<template>
    <div>
        <div class="optional-row mt10" style="padding-left: 0;" v-if="thisStaffId != null">
            <span>当前员工：【{{thisStaffName}}】</span>
        </div>
        <div class="msg-subscr-msanage" v-for="bizTopic in bizTopicList">
            <div v-if="bizTopic.bizEventMsgList != null && bizTopic.bizEventMsgList.length > 0">
                <div class="message-tips">
                    <div class="inline-block mr20">
                        <span class="font-gray1">主题：</span>
                        <span class="font-black font-bold">{{bizTopic.name}}</span>
                    </div>
                    <div class="inline-block mr20">
                        <span class="font-gray1">与商品有关：</span>
                        <span class="font-green" v-if="bizTopic.goodsRelated">是</span>
                        <span class="font-red" v-else>否</span>
                    </div>
                    <div class="inline-block mr20">
                        <span class="font-gray1">与服务有关：</span>
                        <span class="font-green" v-if="bizTopic.servcRelated">是</span>
                        <span class="font-red" v-else>否</span>
                    </div>
                </div>
                <div class="message-body">
                    <ul class="native-table">
                        <li class="table-tr">
                            <div class="table-th" style="width: 150px; text-align: left;">消息名称</div>
                            <div class="table-th" style="text-align: left;">消息内容</div>
                            <div class="table-th" style="width: 100px;">平级机构</div>
                            <div class="table-th" style="width: 100px;">下级机构</div>
                            <div class="table-th" style="width: 100px;">发送站内信</div>
                            <div class="table-th" style="width: 100px;">发送邮件</div>
                            <div class="table-th" style="width: 100px;">微信消息</div>
                            <div class="table-th" style="width: 100px;">VIP级别(及以上)</div>
                            <div class="table-th" style="width: 80px;">操作</div>
                        </li>
                        <li class="table-tr" :class="bizEventMsg.vipLevel <= currentVipLevel ? '' : 'vipCtrl'" v-for="bizEventMsg in bizTopic.bizEventMsgList">
                            <div class="table-td" style="text-align: left;">{{bizEventMsg.name}}</div>
                            <div class="table-td" style="text-align: left;">{{bizEventMsg.renderContent}}</div>
                            <div class="table-td">
                                <span class="font-green" v-if="bizEventMsg.hrTransOrgFlag">支持</span>
                                <span class="font-red" v-else>不支持</span>
                            </div>
                            <div class="table-td">
                                <span class="font-green" v-if="bizEventMsg.vtTransOrgFlag">支持</span>
                                <span class="font-red" v-else>不支持</span>
                            </div>
                            <div class="table-td">
                                <span class="font-green" v-if="bizEventMsg.siteMsgFlag">支持</span>
                                <span class="font-red" v-else>不支持</span>
                            </div>
                            <div class="table-td">
                                <span class="font-green" v-if="bizEventMsg.emailFlag">支持</span>
                                <span class="font-red" v-else>不支持</span>
                            </div>
                            <div class="table-td">
                                <span class="font-green" v-if="bizEventMsg.wxFlag">支持</span>
                                <span class="font-red" v-else>不支持</span>
                            </div>
                            <div class="table-td">{{vipLevel[bizEventMsg.vipLevel]}}</div>
                            <div class="table-td">
                                <a class="swb-btn swb-btn-link" @click="checkBizEventMsgForVip(bizEventMsg.id, bizEventMsg.name, bizEventMsg.topicId)">订阅</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openMsgSubscrDlg } from './dialog'
    //
    import bizMsgApi from '../../api/bizMsg'
    import userApi from '../../api/user'
    //
    import SwbMsgSubscrManageDlg from './MsgSubscrDlg'
    Vue.regist(SwbMsgSubscrManageDlg);
    //
    export default {
        name: 'swb-subscr-manage',
        // path: '/biz/event/msg/subscr/manage-A',
        props: ["staffId", "staffName"],
        desc: ' 跨机构单条消息订阅',
        data: function () {
            return {
                bizTopicList: [],
                thisStaffId: null,
                thisStaffName: null,
                //
                vipLevel: {},
                currentVipLevel: null
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            //
            this.fetchData();
        },
        methods: {
            fetchData: function () {    // 监听route变化重新加载界面...
                // this.thisStaffId = this.$route.query.staffId || null;
                // this.thisStaffName = this.$route.query.staffName || null;
                this.thisStaffId = this.staffId || null;
                this.thisStaffName = this.staffName || null;
                //
                this.vipLevel = getEnumMap("vipLevel", "value2text");
                this.getBizTopicList();
            },
            getBizTopicList: function () {
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizTopicList(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bizTopicList = result.data;
                        // 获取当前商户信息
                        self.getCurrentUserInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.currentVipLevel = userInfo.scopeEntity.vipLevel;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 订阅前 检查是否满足vip级别
            checkBizEventMsgForVip: function (id, name, topicId) {
                let self = this;
                let postData = {};
                postData.id = id;
                let theLoad = MsgBox.loading();
                bizMsgApi.checkBizEventMsgForVip(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let ok = result.data;
                        if(ok) {
                            // 调用 订阅的弹出框
                            self.msgSubscrDlg(id, topicId);
                        } else {
                            MsgBox.warning("您不满足【" + name + "】所要求的的VIP等级！");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 订阅界面弹框
            msgSubscrDlg: function (eventMsgId, topicId) {
                openMsgSubscrDlg(parseInt(this.thisStaffId), eventMsgId, topicId);
            }
        }
    }
</script>

<style>

    .table-tr.vipCtrl:after {
        content: 'vip等级不满足';
        position: absolute;
        left: 20px;
        width: 100px;
        height: 30px;
        display: block;
        text-align: center;
        line-height: 30px;
        background-color: #fff6f6;
        border: 1px solid #D71718;
        color: black;
        opacity: 0.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transform: rotate(-16deg);
        -ms-transform: rotate(-16deg); /* IE 9 */
        -moz-transform: rotate(-16deg); /* Firefox */
        -webkit-transform: rotate(-16deg); /* Safari 和 Chrome */
        -o-transform: rotate(-16deg); /* Opera */
    }

</style>




// WEBPACK FOOTER //
// src/compo/bizMsg/SubscrManage.vue